<template>
  <div :class="{'register-page__row-contacts': isRow}">
    <!-- <a v-if="showPhone" href="tel:+380443777030" class="register-page__phone">
      <img
        src="@/assets/img/components/modals/phone.svg"
        width="20"
        height="20"
        alt="phone"
      /> +38 (044) 377-70-30
    </a> -->
    <a :href="`mailto:${email}`" class="register-page__email">
      <icu-icon class="pc-email" /> {{ email }}
    </a>
  </div>
</template>

<script>
import IcuIcon from '@/components/common/IcuIcon.vue'

export default {
  name: 'PcContacts',
  components: {IcuIcon},
  props: {
    viewType: {
      type: String,
      default: 'vertical'
    },
    showPhone: {
      type: Boolean,
      default: true
    },
    emailTo: {
      type: String,
      default: ''
    }
  },
  computed: {
    email(){

      switch (this.emailTo) {
        case 'onboarding':
          return 'onboarding@icu.ua'
        case 'support':
          return 'support@icu.ua'
        default:
          return 'sales@icu.ua'
      }
    },
    isRow() {
      return this.viewType === 'horizontal'
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";
.register-page__row-contacts {
  display: flex;
  justify-content: space-around;
  padding: 26px 18px 0;
  width: 100%;

  @media (max-width: #{$mobile}) {
    flex-direction: column;
    align-items: center;
  }
}
a {
  display: flex;
  align-items: center;
  padding-bottom: 12px;
  color: #295770;
  font-weight: 700;
  &:hover {
     text-decoration: underline;
   }
  .icu-icon {
    margin-right: 8px;
  }
}
</style>
